/* 
Scaffolded code: this code was scaffolded by the code generator, feel free to change it
Template: ViewModel.cst
 */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MessageStatusUpdateEntityFetchService } from 'src/store/generated/client-sync.generated';
import {
  MessageStatusUpdateProps,
  MessageStatusUpdateViewModelBase,
} from 'src/store/generated/message-status-update-record.generated';

export class MessageStatusUpdateViewModel extends MessageStatusUpdateViewModelBase {
  constructor(props: MessageStatusUpdateProps) {
    super(props);
  }
}

@Injectable({ providedIn: 'root' })
export class MessageStatusUpdateViewModelService {
  constructor(
    private readonly _messageStatusUpdateEntityFetchService: MessageStatusUpdateEntityFetchService,
  ) {}

  public getById(id: string): Observable<MessageStatusUpdateViewModel | undefined> {
    return this._messageStatusUpdateEntityFetchService.getById(id).pipe(
      map((messageStatusUpdate) => {
        if (messageStatusUpdate == null) {
          return undefined;
        }
        return new MessageStatusUpdateViewModel(messageStatusUpdate);
      }),
    );
  }
}
